import { useState } from 'react';

import useMultiChannelOrderList from '../../../../hooks/queries/multiChannel/useMultiChannelOrderList';
import { convertMultiChannelOrderListResponse } from '../libs/convertMultiChannelOrderListResponse';
import { OrderManagementItem } from '../../../../types/multiChannel/orderManagement';
import { Pagination, SearchOption } from '../types';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { DEFAULT_SEARCH_OPTION } from '../../../../constants/service/app/multiChannelConstants';

type FetchMultiChannelOrderList = {
  totalCount: number;
  orderList: OrderManagementItem[];
  refetchOrderList: () => void;
  pagination: Pagination;
  changePagination: (pagination: Pagination) => void;
  searchOption: SearchOption;
  changeSearchOption: (searchOption: SearchOption) => void;
};

type FetchMultiChannelOrderListProps = {
  resetSelectedCheckboxIds: () => void;
};

const useFetchMultiChannelOrderList = (props: FetchMultiChannelOrderListProps): FetchMultiChannelOrderList => {
  const { resetSelectedCheckboxIds } = props;
  const [pagination, setPagination] = useState<Pagination>({
    pageNum: _LIST_PAGINATION_MODEL.pageNum,
    pageSize: _LIST_PAGINATION_MODEL.pageSize,
  });
  const [searchOption, setSearchOption] = useState<SearchOption>(DEFAULT_SEARCH_OPTION);
  const { data, refetch: refetchOrderList } = useMultiChannelOrderList(
    { page: pagination.pageNum + 1, pageSize: pagination.pageSize, ...searchOption },
    { select: (data) => convertMultiChannelOrderListResponse(data) },
  );

  const changePagination = (pagination: Pagination): void => {
    resetSelectedCheckboxIds();
    setPagination(pagination);
  };

  const changeSearchOption = (searchOption: SearchOption): void => {
    resetSelectedCheckboxIds();
    setPagination({ ...pagination, pageNum: _LIST_PAGINATION_MODEL.pageNum });
    setSearchOption(searchOption);
  };

  return {
    totalCount: data?.totalCount || 0,
    orderList: data?.orderList || [],
    refetchOrderList,
    pagination,
    changePagination,
    searchOption,
    changeSearchOption,
  };
};

export default useFetchMultiChannelOrderList;
